import OverlayShell from "./OverlayShell";
import { PassCard } from "./styles";
import { IMAGES } from "./images";

const PassPreview = ({
  guestName,
  groupName,
  hotelName,
  serialNumber,
  onClose
}) => {
  return (
    <OverlayShell
      title="Northbank Pass"
      image={IMAGES.riverside}
      onClose={onClose}
    >
      <div className="section">
        <p>
          A preview of the digital event pass. This demo does not add a pass to
          a phone wallet.
        </p>
      </div>
      <PassCard>
        <p className="pass-brand">Northbank Pass</p>
        <h2>{guestName || "Guest"}</h2>
        <div className="pass-meta">
          <div className="pass-row">
            <span>Event</span>
            <p>Riverside Sessions</p>
          </div>
          <div className="pass-row">
            <span>Group</span>
            <p>{groupName || "Unassigned"}</p>
          </div>
          <div className="pass-row">
            <span>Stay</span>
            <p>{hotelName || "TBC"}</p>
          </div>
          <div className="pass-row">
            <span>Band</span>
            <p>{serialNumber || "—"}</p>
          </div>
        </div>
      </PassCard>
    </OverlayShell>
  );
};

export default PassPreview;
